import img1 from '../img/tshirt/1.jpg'
import img2 from '../img/tshirt/2.jpg'
import img3 from '../img/tshirt/3.jpg'
import img4 from '../img/tshirt/4.jpg'
import img5 from '../img/tshirt/5.jpg'
import img6 from '../img/tshirt/6.jpg'
import img7 from '../img/tshirt/7.jpg'
import img8 from '../img/tshirt/8.jpg'
import img9 from '../img/tshirt/9.jpg'

const creater = {
  Name: ['Rishi'],
}
const gender = ['Man', 'Women']

export const teesdata = [
  {
    id: 1,
    img: `${img1}`,
    name: `Life Hang Buble (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0011',
  },
  {
    id: 2,
    img: `${img2}`,
    name: `Forgive X Forget (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0012',
  },
  {
    id: 3,
    img: `${img3}`,
    name: `Strength (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0013',
  },
  {
    id: 4,
    img: `${img4}`,
    name: `Decoding Women (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0014',
  },
  {
    id: 5,
    img: `${img5}`,
    name: `Stuck in 90's (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0015',
  },
  {
    id: 6,
    img: `${img6}`,
    name: `Music (${gender[1]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0016',
  },
  {
    id: 7,
    img: `${img7}`,
    name: `Best Buddies (${gender[1]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0016',
  },
  {
    id: 8,
    img: `${img8}`,
    name: `Flying Mode (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0016',
  },
  {
    id: 9,
    img: `${img9}`,
    name: `Meme Warrior (${gender[0]})`,
    creater: `${creater.Name[0]}`,
    mrp: '₹499',
    price: '₹299',
    itemNumber: 'ts0016',
  },
]
